import {
  generateGenericDocs,
  GenericMachine,
} from '_core/domain/Utils/Generic/Machines/GenericMachine';
import { IDocs } from '_core/types';
import { ErrorsFlowTypes } from '_core/types/Responses';
import { tokenSmsApi as API } from '../Apis';

const handleErrorFlowFinalResponseFunction = (infos: ErrorsFlowTypes) => {
  const tokenExpired = infos?.tokenExpired;
  const smilesErrorService =
    infos?.errorService || infos?.processFailure || !tokenExpired;

  return { tokenExpired, smilesErrorService };
};

export const ValidateTokenSmsDocs: IDocs = generateGenericDocs(
  {
    title: 'ValidateTokenSms',
    description: '',
    version: '0.0.1',
    codeToExecute: 'Services.AccountServices.validateTokenSms',
  },
  API.definitions,
);

const prepareCall = (stateRequestParameters: any) =>
  API.call.get({
    token: stateRequestParameters?.token,
  });

export const ValidateTokenSmsMachine = GenericMachine(
  prepareCall,
  {
    docs: ValidateTokenSmsDocs,
    definitions: API.definitions,
  },
  {
    handleErrorFlowFinalResponseFunction,
  },
);
